export const capitalizeFirst = <T extends string | undefined>(string?: T) => {
  if (string === undefined) return undefined;
  return (string.charAt(0).toUpperCase() + string.slice(1)) as Capitalize<string>;
};

export const capitalizeAll = <T extends string>(value: T) => value.toUpperCase() as Uppercase<T>;
